"use client";

import React, { useState, useEffect } from "react";
import { Play, ArrowRight, CircleCheck, ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TransformeConteudoEmAprendizado() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll();
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/machu-picchu-cidade-perdida-incas-peru.webp.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/foto-machu-p.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1629973/img/foto-machu-p.png-wvc-sizes",
    alt: "Vista panorâmica de Machu Picchu no Peru"
  }, {
    src: "https://www.kgviagens.com/wp-content/uploads/2026/06/castelo-alnwick-inglaterra-tour-reino-unido-kg-viagens.webp.webp?v=f484gr12d7e",
    srcset: "https://www.kgviagens.com/wp-content/uploads/2026/06/castelo-alnwick-inglaterra-tour-reino-unido-kg-viagens.webp.webp?v=h4ow0fbkas7-wvc-srcset",
    sizes: "https://www.kgviagens.com/wp-content/uploads/2026/06/castelo-alnwick-inglaterra-tour-reino-unido-kg-viagens.webp.webp?v=b08yrawrpyp-wvc-sizes",
    alt: "Mulher elegante desfrutando de um café em uma praça europeia ensolarada"
  }, {
    src: "https://www.kgviagens.com/wp-content/uploads/2026/05/lencois-maranhenses-lagoas-ao-por-do-sol-foto-original.webp.webp?v=x5ospgqq0kn",
    srcset: "https://www.kgviagens.com/wp-content/uploads/2026/05/lencois-maranhenses-lagoas-ao-por-do-sol-foto-original.webp.webp?v=xrk6d4bbhcr-wvc-srcset",
    sizes: "https://www.kgviagens.com/wp-content/uploads/2026/05/lencois-maranhenses-lagoas-ao-por-do-sol-foto-original.webp.webp?v=m999qwmiu38-wvc-sizes",
    alt: "Resort de luxo em uma praia tropical paradisíaca"
  }, {
    src: "https://www.kgviagens.com/wp-content/uploads/2026/06/vista-panoramica-edimburgo-escocia-kg-viagens.webp.webp?v=prmlxx97z4",
    srcset: "https://www.kgviagens.com/wp-content/uploads/2026/06/vista-panoramica-edimburgo-escocia-kg-viagens.webp.webp?v=xrdeui58dk-wvc-srcset",
    sizes: "https://www.kgviagens.com/wp-content/uploads/2026/06/vista-panoramica-edimburgo-escocia-kg-viagens.webp.webp?v=4a513tkpmt-wvc-sizes",
    alt: "Pôr do sol deslumbrante em Santorini na Grécia"
  }];
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);
  const nextSlide = () => setCurrentSlide(prev => (prev + 1) % slides.length);
  const prevSlide = () => setCurrentSlide(prev => (prev - 1 + slides.length) % slides.length);
  return <section data-section-id="16443" id="sua-próxima-jornada-com-elegância" className="relative w-full overflow-hidden bg-background pt-12 pb-10 lg:pt-16 lg:pb-12">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none z-0">
        <div className="absolute top-20 right-0 w-[500px] h-[500px] bg-secondary/5 rounded-lg blur-3xl opacity-50 mix-blend-multiply animate-pulse" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-primary/10 rounded-lg blur-3xl opacity-40 mix-blend-multiply" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid gap-12 grid-cols-1 items-center">
          
          <div ref={imageRef} className={`relative w-full max-w-[90%] mx-auto transition-all duration-1000 delay-200 ease-out ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            <div className="relative aspect-[21/7] w-full group">
              <div className="absolute inset-0 rounded-3xl bg-linear-to-br from-secondary/5 to-primary/5 border border-white/20 backdrop-blur-sm shadow-2xl overflow-hidden">
                {slides.map((slide, index) => <div key={index} data-index={index} className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${index === currentSlide ? "opacity-100 z-10" : "opacity-0 z-0"}`}>
                    <img src={slide.src} data-wvc-srcset={slide.srcset} data-wvc-sizes={slide.sizes} alt={slide.alt} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700 ease-in-out" loading="lazy" />
                  </div>)}

                {}
                <Button variant="ghost" size="icon" onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 z-20 rounded-lg bg-white/10 backdrop-blur-md border border-white/20 text-white opacity-0 group-hover:opacity-100 transition-opacity hover:bg-white/20" aria-label="Slide anterior">
                  <ChevronLeft className="h-6 w-6" />
                </Button>
                <Button variant="ghost" size="icon" onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 z-20 rounded-lg bg-white/10 backdrop-blur-md border border-white/20 text-white opacity-0 group-hover:opacity-100 transition-opacity hover:bg-white/20" aria-label="Próximo slide">
                  <ChevronRight className="h-6 w-6" />
                </Button>

                {}
                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 flex gap-2">
                  {slides.map((_, index) => <Button key={index} variant="ghost" onClick={() => setCurrentSlide(index)} className={`p-0 h-1.5 min-w-0 rounded-lg transition-all duration-300 hover:bg-transparent ${index === currentSlide ? "w-8 bg-white" : "w-2 bg-white/40"}`} aria-label={`Ir para slide ${index + 1}`} />)}
                </div>
              </div>
            </div>
          </div>

          
          <div ref={textRef} className={`flex flex-col justify-center items-center space-y-8 transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="space-y-4 flex flex-col items-center">
              <h1 className="text-5xl font-default font-bold tracking-tight text-foreground sm:text-6xl xl:text-7xl/none text-center">
                Experiências de Viagem{" "}
                <span className="relative inline-block !text-[rgba(27,164,172,1)]">
                  Pelo Mundo
                  <svg className="absolute w-full h-3 -bottom-1 left-0 text-primary -z-10" viewBox="0 0 100 10" preserveAspectRatio="none">
                    <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="8" fill="none" />
                  </svg>
                </span>
              </h1>

              <p className="max-w-[650px] font-default text-lg sm:text-xl leading-relaxed text-foreground text-center lg:line-clamp-2">
                Sinta o máximo conforto e suporte com planejamento personalizado para suas próximas férias inesquecíveis em destinos exclusivos.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <Button asChild size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive h-10 has-[>svg]:px-4 text-white border-0 shadow-lg shadow-primary/20 transition-transform rounded-lg px-8 !bg-[rgba(244,114,1,1)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90 hover:opacity-90 hover:scale-105">
                <Link to="https://wa.me/48988221618">Falar no WhatsApp</Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="border-secondary/20 text-secondary hover:bg-secondary/5 hover:text-secondary transition-all rounded-lg">
                <Link to="/AboutUsPage">Saiba Mais</Link>
              </Button>
            </div>

            <div className="flex items-center gap-4 text-sm text-muted-foreground font-default">
              <div className="flex items-center gap-1.5">
                <CircleCheck className="h-4 w-4 text-secondary" />
                <span className="text-foreground">Roteiros Exclusivos</span>
              </div>
              <div className="h-1 w-1 rounded-lg bg-border" />
              <div className="flex items-center gap-1.5">
                <CircleCheck className="h-4 w-4 text-secondary" />
                <span className="text-foreground">Suporte Personalizado</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}